export default {
  workshop: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbSolutions: 'الحلول',
    breadcrumbCurrent: 'الورش والحرف',
    hero: {
      eyebrow: 'الورش والحرف',
      title: 'تقنية أمان متينة للبيئات القاسية',
      lead: 'الغبار والرطوبة وتقلبات الحرارة – الورش تفرض متطلبات خاصة. نركّب كاميرات تواكب ذلك.',
    },
    areas: {
      title: 'مجالات الاستخدام في الورش والحرف',
      lead: 'من منطقة الورشة إلى الساحة الخارجية – نؤمّن أدواتك وآلاتك ومركباتك الثمينة.',
      items: {
        '0': { title: 'قاعة الورشة', desc: 'القاعات المرتفعة ذات الآلات تحتاج كاميرات متينة بدقة جيدة – حتى في الإضاءة الصعبة.' },
        '1': { title: 'منطقة الورشة', desc: 'الأدوات وقطع الغيار والأعمال الجارية: المراقبة تحمي مساحة عملك وتوضح الشكاوى.' },
        '2': { title: 'منطقة التحميل', desc: 'التحميل والتفريغ نوافذ للسرقة. كاميرات منطقة التحميل توثّق كل عملية بموثوقية.' },
        '3': { title: 'منطقة الآلات', desc: 'التصنيع الحديث يتطلب توثيقًا كاملًا للعمليات – حتى بين الآلات.' },
        '4': { title: 'الساحة والموقف', desc: 'المركبات والمقطورات والمواد – الساحة تحتاج كاميرات مقاومة للطقس برؤية ليلية جيدة.' },
        '5': { title: 'المكتب والإدارة', desc: 'العروض والفواتير وبيانات العملاء في المكتب. هنا أيضًا لا تُهمل السلامة.' },
      },
    },
    robust: {
      eyebrow: 'المتانة',
      title: 'مصممة للاستخدام الشاق',
      lead: 'الورش ليست صالات عرض. كاميراتنا مصنوعة لهذه البيئات وتُختار خصيصًا لظروفك.',
      items: {
        '0': { title: 'فئة حماية عالية', desc: 'أغلفة IP66 تحمي من الغبار ورذاذ الماء والمطر – حتى في الاستخدام الخارجي المستمر.' },
        '1': { title: 'مقاومة للحرارة والرطوبة', desc: 'من المستودع المتجمد إلى الورشة الدافئة: نختار كاميرات لكل نطاق حراري.' },
        '2': { title: 'أغلفة مقاومة للغبار', desc: 'في البيئات المغبرة، تحافظ الأغلفة والجوانات الخاصة على وضوح العدسة لسنوات.' },
      },
    },
    maintenance: {
      eyebrow: 'الصيانة والعناية',
      title: 'ليبقى نظامك موثوقًا',
      lead: 'في البيئات المغبرة والقاسية، تحدد العناية العمر الافتراضي. مع SSG Care يبقى نظامك جاهزًا دائمًا.',
      list: {
        '0': 'فحوصات دورية من SSG Care – حتى خارج الضمان',
        '1': 'تنظيف وفحص بصري للغلاف والعدسة',
        '2': 'تحديثات البرامج الثابتة والأمان حسب الحاجة',
        '3': 'استجابة سريعة للأعطال',
        '4': 'خيارات قطع الغيار والترقية لنظامك',
      },
      note: 'ملاحظة: تعتمد شرعية المراقبة بالفيديو على الحالة الفردية. ننصحك دون أن نغني عن الاستشارة القانونية.',
    },
    cta: {
      title: 'ورشتك تستحق نظرة آمنة',
      lead: 'ننصحك دون التزام بأي كاميرات تتحمل بيئتك – وأين تحمي أكثر.',
      primary: 'احجز موعد استشارة',
      secondary: 'اكتشف SSG Care',
    },
  },
};